import type { ReactElement } from "react";
import { Route } from "react-router";
import * as ROUTES from "../constants/routes";
import { DeliveryPreferencesFlow } from "../pages/auth/orderSummary/deliveryPreferences/DeliveryPreferencesFlow";
import { EditAddSelectionPage } from "../pages/auth/orderSummary/editAddSelection/EditAddSelectionPage";
import { PaymentLink } from "../pages/paymentLinks/PaymentLink";
import { OrderSummary } from "~/pages";

/** Link flows that can initialize without a complete authenticated session. */
export const renderExternalFlowRoutes = (): ReactElement => (
  <>
    <Route path={ROUTES.ORDER_SUMMARY} element={<OrderSummary />} />
    <Route
      path={ROUTES.ORDER_SUMMARY_DELIVERY_PREFERENCES}
      element={<DeliveryPreferencesFlow />}
    />
    <Route
      path={ROUTES.ORDER_SUMMARY_EDIT_ADD_SELECTION}
      element={<EditAddSelectionPage />}
    />
    <Route path={ROUTES.PAYMENT_LINK_REF.pattern} element={<PaymentLink />} />
  </>
);
